import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleRoadTaxDto } from './create-vehicle-road-tax.dto';

/**
 * Update vehicle road tax DTO
 */
export class UpdateVehicleRoadTaxDto extends CreateVehicleRoadTaxDto {
	@TransformInt()
	id!: number;
}
